import React from "react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/app/ui-bits";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectRiskIssueChange from "@/components/app/ProjectRiskIssueChange";
import { Warning, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function IssuesPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/issues?project_id=${project.id}`, [project.id]);
  return (
    <div data-testid={`panel-issues-${project.id}`}>
      <PanelHeader icon={Warning} title="Issue Log" subtitle="F-PM-26 · open and resolved issues"
        action={<ProjectRiskIssueChange project={project} trigger={<Button size="sm" variant="outline">Manage <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No issues logged. Open Manage to capture project issues." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 20).map((r) => (
            <li key={r.id}
                onClick={() => inspector.open(r, { title: r.title || "Issue", subtitle: `${r.priority || "—"} · ${r.status || "—"}` })}
                data-testid={`issue-row-${r.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-16">{r.priority || "—"}</span>
              <span className="min-w-0 flex-1 truncate">{r.title || "Untitled issue"}</span>
              <StatusBadge status={r.status} />
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
